<div class="image-secure-wrapper" (mouseover)="mouseOver()" (mouseout)="mouseOut()">
  @if (showDownloadButton) {
    <button class="btn btn-primary" [ngClass]="{'hide-button': hideImage}" (click)="downloadImage()">
      <i class="glyphicon glyphicon-download-alt"></i>
    </button>
  }

  <div class="disable-text-selection" [class.disable-pointers-events]="disablePointerEvents">
    <ng-content> </ng-content>
  </div>
</div>
